import API from "./axios";

// Advance outstanding per bucket (Advance, Loan / Baki, Machinery, Purchase,
// PF, ESI, PT) for employees and contractors.
//   list({ partyType: "ALL" | "EMPLOYEE" | "CONTRACTOR" })
//   forParty("EMPLOYEE" | "CONTRACTOR", id) -> [] when he owes nothing
const advanceOutstandingApi = {
  list: (params = {}) => API.get("/advance-outstanding", { params }),
  forParty: (partyType, partyId) => API.get("/advance-outstanding", { params: { partyType, partyId } }),
};

export default advanceOutstandingApi;
